/**
 * Trybe — Phone model catalogue (India market)
 * Each model's `tag` matches the Shopify product tag used to filter
 * Mobile Covers / Screen Guards / Theme Based Packages by compatibility.
 * Edit/extend this list any time — no app or redeploy required beyond
 * re-uploading this file (Online Store > Themes > Edit code).
 */
window.TRYBE_PHONE_MODELS = {
  "Apple": [
    "iPhone SE (2022)", "iPhone 11", "iPhone 11 Pro", "iPhone 11 Pro Max",
    "iPhone 12", "iPhone 12 Mini", "iPhone 12 Pro", "iPhone 12 Pro Max",
    "iPhone 13", "iPhone 13 Mini", "iPhone 13 Pro", "iPhone 13 Pro Max",
    "iPhone 14", "iPhone 14 Plus", "iPhone 14 Pro", "iPhone 14 Pro Max",
    "iPhone 15", "iPhone 15 Plus", "iPhone 15 Pro", "iPhone 15 Pro Max",
    "iPhone 16e", "iPhone 16", "iPhone 16 Plus", "iPhone 16 Pro", "iPhone 16 Pro Max"
  ],
  "Samsung": [
    "Galaxy S21", "Galaxy S21+", "Galaxy S21 Ultra",
    "Galaxy S22", "Galaxy S22+", "Galaxy S22 Ultra",
    "Galaxy S23", "Galaxy S23+", "Galaxy S23 Ultra", "Galaxy S23 FE",
    "Galaxy S24", "Galaxy S24+", "Galaxy S24 Ultra", "Galaxy S24 FE",
    "Galaxy S25", "Galaxy S25+", "Galaxy S25 Ultra",
    "Galaxy Note 20", "Galaxy Note 20 Ultra",
    "Galaxy Z Flip 5", "Galaxy Z Flip 6", "Galaxy Z Fold 5", "Galaxy Z Fold 6",
    "Galaxy A14", "Galaxy A15", "Galaxy A16", "Galaxy A25", "Galaxy A34",
    "Galaxy A35", "Galaxy A54", "Galaxy A55", "Galaxy M14", "Galaxy M34"
  ],
  "OnePlus": [
    "OnePlus 9", "OnePlus 9 Pro", "OnePlus 9R",
    "OnePlus 10 Pro", "OnePlus 10R", "OnePlus 10T",
    "OnePlus 11", "OnePlus 11R",
    "OnePlus 12", "OnePlus 12R",
    "OnePlus 13", "OnePlus 13R",
    "OnePlus Nord 2", "OnePlus Nord 3", "OnePlus Nord CE 3",
    "OnePlus Nord CE 4", "OnePlus Nord 4"
  ],
  "Nothing": [
    "Phone (1)", "Phone (2)", "Phone (2a)", "Phone (2a) Plus",
    "Phone (3a)", "Phone (3a) Pro", "Phone (3)"
  ],
  "Xiaomi / Redmi / POCO": [
    "Redmi Note 12", "Redmi Note 13", "Redmi Note 13 Pro", "Redmi Note 14 Pro",
    "Xiaomi 13", "Xiaomi 14", "Xiaomi 14 Civi",
    "POCO X6", "POCO X6 Pro", "POCO F6", "POCO M6 Pro"
  ],
  "Vivo": [
    "Vivo V29", "Vivo V30", "Vivo V40", "Vivo Y200", "Vivo X100"
  ],
  "Oppo": [
    "Oppo Reno 10", "Oppo Reno 11", "Oppo Reno 12", "Oppo F25", "Oppo A79"
  ],
  "Realme": [
    "Realme 12 Pro", "Realme 12 Pro+", "Realme GT 6", "Realme Narzo 70"
  ],
  "Google": [
    "Pixel 7", "Pixel 7 Pro", "Pixel 8", "Pixel 8 Pro", "Pixel 8a", "Pixel 9", "Pixel 9 Pro"
  ]
};

// Convert a model name to the exact product tag format used across the store.
// e.g. "iPhone 15 Pro Max" -> "model-iphone-15-pro-max"
window.trybeModelToTag = function (modelName) {
  return (
    "model-" +
    modelName
      .toLowerCase()
      .replace(/[()]/g, "")
      .replace(/\+/g, "-plus")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
  );
};
